import React, { useEffect, useState } from "react";
import { Gauge, Save } from "lucide-react";
import { practiceApi } from "../../lib/practiceApi";

const WEIGHTS = [["productivity", "Produttività"], ["control", "Controllo operativo"], ["commercial", "Commerciale"], ["collections", "Incassi"]];

export const MomentumSettings = () => {
  const [form, setForm] = useState(null);
  const [state, setState] = useState({ busy: false, error: "", done: "" });
  useEffect(() => { practiceApi("/momentum/settings").then(setForm).catch(() => {}); }, []);
  if (!form) return null;
  const total = WEIGHTS.reduce((sum, [key]) => sum + Number(form.weights[key] || 0), 0);

  async function save(event) {
    event.preventDefault();
    setState({ busy: true, error: "", done: "" });
    try {
      const saved = await practiceApi("/momentum/settings", { method: "PUT", body: JSON.stringify(form) });
      setForm(saved);
      setState({ busy: false, error: "", done: saved.enabled === false ? "Momentum disattivato: la dashboard mostra solo la barra di benvenuto." : "Obiettivi aggiornati: il Momentum si ricalcola al prossimo accesso alla dashboard." });
    } catch (err) { setState({ busy: false, error: err.message, done: "" }); }
  }

  const off = form.enabled === false;
  return <form onSubmit={save} data-testid="momentum-settings" className={off ? "momentum-form off" : "momentum-form"}>
    <label className="momentum-switch" data-testid="momentum-enabled-row">
      <input type="checkbox" role="switch" data-testid="momentum-enabled" checked={form.enabled !== false}
        onChange={e => setForm({ ...form, enabled: e.target.checked })} />
      <span><strong>INGEGO MOMENTUM attivo</strong><small>Se lo disattivi, la dashboard torna alla sola barra di benvenuto blu scuro.</small></span>
    </label>
    <p className="muted" style={{ fontSize: 12.5 }}>Il Momentum misura solo ciò che dipende dallo studio. Qui imposti gli obiettivi e il peso di ogni componente (la somma dei pesi deve essere 100).</p>
    <div className="practice-form-grid" style={off ? { opacity: .5, pointerEvents: "none" } : undefined}>
      <label>Obiettivo incassi mensile (€)<input type="number" min="0" step="100" data-testid="momentum-income-goal"
        value={form.monthly_income_goal} onChange={e => setForm({ ...form, monthly_income_goal: Number(e.target.value) })} /></label>
      <label>Attività interne da completare a settimana<input type="number" min="1" data-testid="momentum-weekly-activities"
        value={form.weekly_activities} onChange={e => setForm({ ...form, weekly_activities: Number(e.target.value) })} /></label>
      <label>Preventivi da gestire a settimana<input type="number" min="1" data-testid="momentum-weekly-quotes"
        value={form.weekly_quotes} onChange={e => setForm({ ...form, weekly_quotes: Number(e.target.value) })} /></label>
      <label>Tolleranza attività interne scadute<input type="number" min="1" data-testid="momentum-tolerance"
        value={form.overdue_tolerance} onChange={e => setForm({ ...form, overdue_tolerance: Number(e.target.value) })} /></label>
    </div>
    <fieldset className="practice-fieldset" style={off ? { opacity: .5, pointerEvents: "none" } : undefined}><legend>Pesi del punteggio ({total}%)</legend><div className="practice-form-grid">
      {WEIGHTS.map(([key, label]) => <label key={key}>{label} (%)
        <input type="number" min="0" max="100" data-testid={`momentum-weight-${key}`} value={form.weights[key]}
          onChange={e => setForm({ ...form, weights: { ...form.weights, [key]: Number(e.target.value) } })} />
      </label>)}
    </div></fieldset>
    {state.error && <div className="error" role="alert" data-testid="momentum-settings-error">{state.error}</div>}
    {state.done && <div className="flash" data-testid="momentum-settings-saved">{state.done}</div>}
    <div className="settings-actions">
      <button className="primary" type="submit" disabled={state.busy} data-testid="momentum-settings-save"><Save size={15} />{state.busy ? "Salvo…" : "Salva obiettivi"}</button>
      <span className="muted" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 11.5 }}><Gauge size={13} />Le attese di enti, clienti e imprese non abbassano mai il punteggio.</span>
    </div>
  </form>;
};
